<template>
    <el-dialog :title="title" :visible.sync="showBlock" :close-on-click-modal="false" :destroy-on-close="true" width='430px'
        :before-close="closedBtn">
        <el-form :model="formDate" status-icon :rules="rules" ref="formDate" label-width="80px" class="demo-ruleForm">
            <el-form-item label="动作名称" prop="name">
                <el-input v-model="formDate.name" maxlength="9" :size="this.$store.state.popSize" placeholder="请输入报警名称"
                    autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="动作主题" prop="topic">
                <el-input v-model="formDate.topic" maxlength="9" :size="this.$store.state.popSize" placeholder="请输入报警名称"
                    autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="操作指令" prop="cmd">
                <el-input v-model="formDate.cmd" maxlength="9" :size="this.$store.state.popSize" placeholder="请输入报警名称"
                    autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="动作状态" v-if='mark == "eidt"'>
                <el-select v-model="formDate.status" placeholder="请选择" :size="this.$store.state.popSize">
                    <el-option v-for="item in this.$store.state.conText.stateList" :key="item.val" :label="item.title"
                        :value="item.val"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="dialog-footer">
                    <el-button @click="closedBtn">取消</el-button>
                    <el-button type="primary" v-if="showBtn">
                        <i class="el-icon-loading"></i>提交
                    </el-button>
                    <el-button type="primary" v-else @click="submitForm('formDate')">提交</el-button>
                </div>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import { isEmpty } from '@/utils/util'
import { postFun, putFun } from '@/utils/httpFun'
import { operate, iotApi } from '@/utils/config'
import { conText } from '@/utils/configText'
export default {
    components: {

    },
    data: () => ({
        showBlock: false,
        showBtn: false,
        mark: "add",
        title: "",
        formDate: {
            name: "",
            status: 1,
            deviceTypeId: "",
            topic: "",
            cmd: "",
        },
        rules: {
            name: [{ required: true, message: '不可为空', trigger: 'blur' }],
            topic: [{ required: true, message: '不可为空', trigger: 'blur' }],
            cmd: [{ required: true, message: '不可为空', trigger: 'blur' }]
        }
    }),

    mounted() {

    },
    methods: {

        //关闭窗口
        closedBtn() {
            this.showBlock = false
        },

        //打开窗口
        openBtn(ev) {
            console.log(ev)
            if (ev.mark == "add") {
                this.formDate.topic = ""
                this.formDate.cmd = ""
                this.formDate.name = ""
                this.title = "新增指令"
            } else {
                this.formDate.id = ev.listData.id
                this.formDate.status = ev.listData.status
                this.formDate.topic = ev.listData.topic
                this.formDate.cmd = ev.listData.cmd
                this.formDate.name = ev.listData.name
                this.title = "编辑指令"
            }
            this.mark = ev.mark
            this.formDate.deviceTypeId = ev.deviceTypeId
            this.showBlock = true
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitBtn()
                } else {
                    return false;
                }
            });
        },

        //提交
        submitBtn() {
            postFun(iotApi.ADDCMD, this.formDate, res => {
                if (res.data) {
                    this.closedBtn()
                    this.$parent.resetBtn()
                } else {
                    this.$message.warning("网络繁忙");
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.dialog-footer {
    display: flex;
    justify-content: flex-end;
}

.zhu {
    bottom: 0px;
    left: 0px;
}

::v-deep .el-input-number .el-input__inner {
    text-align: left !important;
}

.warp-btn {
    margin-top: 20px;

    .el-form-item {
        margin-bottom: 0px !important;
    }
}</style>